/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { COUNTRY } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import ModelAndSiteInfoSection from './ModelAndSiteInfoSection.jsx';

const mapStateToProps = (state, ownProps) => ({
  country: modelTypesByForm[ownProps.form].selectFormValues(state, COUNTRY),
});

export default connect(mapStateToProps)(ModelAndSiteInfoSection);
